import { render, staticRenderFns } from "./ProjCost.vue?vue&type=template&id=48a1477c"
import script from "./ProjCost.vue?vue&type=script&lang=js"
export * from "./ProjCost.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports